import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import AffiliateModal from './AffiliateModal';
import modalDecorator from 'apex-web/lib/hocs/modalDecorator';
import { MODAL_TYPES } from 'apex-web/lib/redux/actions/modalActions';
import {
  getAffiliate,
  updateAffiliate
} from 'apex-web/lib/redux/actions/affiliateActions';

const mapStateToProps = state => {
  const { affiliate } = state;

  return {
    initialValues: {
      tag: affiliate.affiliateTag
    }
  };
};

const mapDispatchToProps = { getAffiliate };

const Form = reduxForm({
  form: 'updateAffiliate',
  onSubmit: (payload, dispatch) => dispatch(updateAffiliate(payload)),
  enableReinitialize: true
})(AffiliateModal);

const container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Form);

export default modalDecorator({
  name: MODAL_TYPES.NEW_AFFILIATE_KEY
})(container);
